module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eALux"))).then(() => parcelRequire('hEqeo'));